import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const SettingsModalsFieldsView = angular
  .module('acme.view.application.settings.modals.fields', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.settings.modals.fields.controllers',
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const settingsModalsAssign = {
      name: 'application.settings.modals.fields',
      url: '/settings/modals/fields',
      views: {
        main: {
          controller: 'SettingsModalsFieldsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/settings/modals/fields/fields.tpl.html',
        },
      },
      data: {
        pageTitle: '   ',
        /** Secure With Permissions **/
        permissions: [],
      },
    };

    $stateProvider.state(settingsModalsAssign);
  }).name;
